import React from 'react'

const MyAppointment = () => {
  return (
    <div className='flex justify-center items-center'>
      <h1>HELLO WE HAVE REACHED</h1>
    </div>
  )
}

export default MyAppointment
